module.exports = __webpack_public_path__ + "promotion-banner-mobile.b46ffb010d3d5b4b3df97f8bcc73e5ea.png";